import React from "react";
import {
  Routes,
  Route,
  BrowserRouter as Router,
  Outlet,
  Navigate,
} from "react-router-dom";

import { ToastContainer } from "react-toastify";
import FrontLayout from "./components/Front/FrontLayout";
import LandingPage from "./pages/landingPage";
import StarshipViewBackground from "./components/StarshipViewBackground";
import ExploreRedeme from "./pages/landingPage/ExploreRedeme";
import HowItWorksSection from "./pages/landingPage/HowItWorksSection";
import FeaturesSection from "./pages/landingPage/FeaturesSection";
import TermsAndConditions from "./pages/Home/TermsAndConditions";
import PrivacyPolicy from "./pages/Home/PrivacyPolicy";
import ContactPage from "./pages/Home/ContactPage";
import Blog from "./pages/Blog";
import BlogDetails from "./pages/Blog/BlogDetails";
import ComingSoonSection from "./pages/Home/ComingSoonSection";
import About from "./pages/Home/About";
import FeatureDetails from "./pages/landingPage/FeatureDetails";
import { Provider } from "react-redux";
import { store } from "./store";
import AdminLayout from "./components/Admin/AdminLayout";
import SimpleDashboard from "./pages/dashboard";
import RewardPrograms from "./pages/rewardPrograms";
import Cards from "./pages/cards";
import CardCategories from "./pages/cardCategories";
import TransferPartners from "./pages/transferPartners";
import Deals from "./pages/deals";
import Users from "./pages/users";
import AddRewardPrograms from "./pages/rewardPrograms/AddRewardPrograms";
import FrontDashboard from "./pages/Front/FrontDashboard";
import AnalyzeSearch from "./pages/Front/AnalyzeSearch";
import RedemptionResults from "./pages/Front/RedemptionResults";
import RedemptionDetails from "./pages/Front/RedemptionResults/RedemptionDetails";
import PointSetupScreen from "./pages/Front/PointSetup";
import PortfolioSummary from "./pages/Front/PointSetup/PortfolioSummary";
import AddCards from "./pages/cards/AddCards";
import AddCardCategories from "./pages/cardCategories/AddCardCategories";
import AddTransferPartners from "./pages/transferPartners/AddTransferPartners";
import AdminLogin from "./pages/auth/adminLogin";
import { PrivateRoute, PublicRoute } from "./utils/function";
import NoURLFoundPage from "./components/Common/NoURLFoundPage";
import Login from "./pages/auth/Login";
import Signup from "./pages/auth/SignUp";
import DashboardScreen from "./pages/Front/FrontDashboard";
import PointWallet from "./pages/Front/PointWallet";
import Profile from "./pages/Profile";
import SaveDeal from "./pages/Front/SaveDeal";
import CardSelection from "./pages/Front/AnalyzeSearch/CardSelection";
import { SearchProvider } from "./context/SearchContext";

const App = () => {
  return (
    <React.Fragment>
      {/* </Provider> */}
      <SearchProvider>
        <Provider store={store}>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
          <Router>
            <Routes>
              {/* PUBLIC ROUTES */}
              <Route element={<PublicRoute />}>
                <Route
                  path="/"
                  element={
                    <FrontLayout>
                      <StarshipViewBackground>
                        <LandingPage />
                      </StarshipViewBackground>
                    </FrontLayout>
                  }
                />
                <Route
                  path="/redemption-opportunities"
                  element={
                    <FrontLayout>
                      <ExploreRedeme />
                    </FrontLayout>
                  }
                />
                <Route
                  path="/how-it-works"
                  element={
                    <FrontLayout>
                      <HowItWorksSection />
                    </FrontLayout>
                  }
                />

                <Route
                  path="/features"
                  element={
                    <FrontLayout>
                      <FeaturesSection />
                    </FrontLayout>
                  }
                />

                <Route
                  path="/features/:slug"
                  element={
                    <FrontLayout>
                      <FeatureDetails />
                    </FrontLayout>
                  }
                />

                <Route
                  path="/terms"
                  element={
                    <FrontLayout>
                      <TermsAndConditions />
                    </FrontLayout>
                  }
                />

                <Route
                  path="/privacy-policy"
                  element={
                    <FrontLayout>
                      <PrivacyPolicy />
                    </FrontLayout>
                  }
                />

                <Route
                  path="/contact"
                  element={
                    <FrontLayout>
                      <ContactPage />
                    </FrontLayout>
                  }
                />

                <Route
                  path="/about"
                  element={
                    <FrontLayout>
                      <About />
                    </FrontLayout>
                  }
                />

                <Route
                  path="/coming-soon"
                  element={
                    <FrontLayout>
                      <ComingSoonSection />
                    </FrontLayout>
                  }
                />

                <Route
                  path="/blog"
                  element={
                    <FrontLayout>
                      <Blog />
                    </FrontLayout>
                  }
                />
                <Route
                  path="/blog/:slug"
                  element={
                    <FrontLayout>
                      <BlogDetails />
                    </FrontLayout>
                  }
                />

                <Route path="/secure/login" element={<AdminLogin />} />
                <Route path="/login" element={<Login />} />
                <Route path="/sign-up" element={<Signup />} />
              </Route>
              <Route element={<PrivateRoute />}>
                <Route element={<AdminLayout />}>
                  <Route path="/dashboard" element={<SimpleDashboard />} />
                  <Route
                    path="/dashboard-screen"
                    element={<DashboardScreen />}
                  />
                  <Route path="/profile" element={<Profile />} />

                  <Route path="/reward-programs" element={<RewardPrograms />} />
                  <Route
                    path="/reward-programs-add"
                    element={<AddRewardPrograms />}
                  />
                  <Route
                    path="/reward-programs-update/:uuid"
                    element={<AddRewardPrograms />}
                  />
                  <Route path="/cards" element={<Cards />} />
                  <Route path="/cards-add" element={<AddCards />} />
                  <Route path="/cards-update/:uuid" element={<AddCards />} />

                  <Route path="/card-categories" element={<CardCategories />} />
                  <Route
                    path="/card-categories-add"
                    element={<AddCardCategories />}
                  />
                  <Route
                    path="/card-categories-update/:uuid"
                    element={<AddCardCategories />}
                  />

                  <Route
                    path="/transfer-partners"
                    element={<TransferPartners />}
                  />
                  <Route
                    path="/transfer-partners-add"
                    element={<AddTransferPartners />}
                  />
                  <Route
                    path="/transfer-partners-update/:uuid"
                    element={<AddTransferPartners />}
                  />
                  <Route
                    path="/profile-point-wallet"
                    element={<PointWallet />}
                  />
                  <Route path="/search" element={<AnalyzeSearch />} />
                  <Route path="/points-wallet" element={<PointSetupScreen />} />
                  <Route
                    path="/portfolio-summary"
                    element={<PortfolioSummary />}
                  />

                  <Route path="/results" element={<RedemptionResults />} />
                  <Route
                    path="/deals-details"
                    element={<RedemptionDetails />}
                  />
                  <Route path="/deals" element={<Deals />} />
                  <Route path="/users" element={<Users />} />
                  <Route path="/deal-saved" element={<SaveDeal />} />
                  <Route path="/card-select" element={<CardSelection />} />
                </Route>
              </Route>
              <Route path="*" element={<NoURLFoundPage />} />
            </Routes>
          </Router>
        </Provider>
      </SearchProvider>
    </React.Fragment>
  );
};

export default App;
